<template>
  <span
    :class="[
      'asc-label',
      sizeClass,
      uppercaseClass,
      typeClass,
      prependIcon ? 'asc-label-icon asc-label-icon--prepend' : '',
      appendIcon ? 'asc-label-icon asc-label-icon--append' : '',
    ]"
    :style="{ color: color }"
  >
    <template v-if="prependIcon">
      <v-icon size="16" class="prependIcon">{{ prependIcon }}</v-icon>
    </template>
    {{ value }}
    <template v-if="appendIcon">
      <v-icon size="16" class="appendIcon">{{ appendIcon }}</v-icon>
    </template>
  </span>
</template>

<script>
import { AscFontSizeMixin, AscLabelPropsMixin } from '@/components/mixins'

export default {
  name: 'AscLabel',

  mixins: [AscFontSizeMixin, AscLabelPropsMixin],

  computed: {
    uppercaseClass() {
      return this.uppercase ? 'asc-label--uppercase' : ''
    },
    sizeClass() {
      return `asc-label--font-${this.size}`
    },
    typeClass() {
      return this.inputLabel ? 'asc-label--input' : ''
    },
  },
}
</script>

<style lang="scss" scoped>
.asc-label {
  color: $primary-black;
  &.asc-label-icon {
    .v-icon {
      position: absolute;
      top: 1px;

      &.prependIcon {
        left: 0;
      }

      &.appendIcon {
        right: 0;
      }
    }

    &.asc-label-icon--prepend {
      padding-left: 16px;
    }

    &.asc-label-icon--append {
      padding-right: 16px;
    }
  }
}
.asc-label--input {
  color: $gray-500;
}
.asc-label--uppercase {
  text-transform: uppercase;
}
.asc-label--font-xs {
  font-size: $font-size-xs;
  line-height: $line-height-xs;
}
.asc-label--font-sm {
  font-size: $font-size-sm;
  line-height: $line-height-sm;
}
.asc-label--font-md {
  font-size: $font-size-md;
  line-height: $line-height-md;
}
.asc-label--font-lg {
  font-size: $font-size-lrg;
  line-height: $line-height-lrg;
}
.asc-label--font-xl {
  font-size: $font-size-xl;
  line-height: $line-height-xl;
}
.asc-label--font-xxl {
  font-size: $font-size-xxl;
  line-height: $line-height-xxl;
}
.asc-label--font-xxxl {
  font-size: $font-size-xxxl;
  line-height: $line-height-xxxl;
}
.asc-label--font-xxxxl {
  font-size: $font-size-xxxxl;
  line-height: $line-height-xxxxl;
}
</style>
